export default "__VITE_ASSET__z5LIHb2m__"